// import './App.css'

// function App() {
//   return (
//     <div className="App">
//         <div className="AppGlass">

//           <Login/>
//         </div>
//     </div>
//   );
// }

// export default App;



import './App.css'
import React from 'react';

import Rtr from './Router'



function App() {
  return (
    <div>
    
      <Rtr/>
    </div>
  );
}

export default App;
